<script setup lang="ts">
import {
    LazyContentAccessibilityCs,
    LazyContentAccessibilityDe,
    LazyContentAccessibilityEn,
    LazyContentAccessibilityEs,
    LazyContentAccessibilityFr,
    LazyContentAccessibilityNl,
    LazyContentAccessibilityIt,
    LazyContentAccessibilityPl,
    LazyContentAccessibilityPt,
    LazyContentAccessibilityRo,
    LazyContentAccessibilityRu,
} from '#components';
import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { locale, tt } = useTypedI18n();

useSeoMeta({
    title: tt('seo.accessibilityStatement.title'),
    ogTitle: tt('seo.accessibilityStatement.title'),
    description: tt('seo.accessibilityStatement.description'),
    ogDescription: tt('seo.accessibilityStatement.description'),
});

// DATA
const currentComponent = computed<Component>(() => {
    const componentByLocale: Record<Locale, Component> = {
        [Locale.CS]: LazyContentAccessibilityCs,
        [Locale.DE]: LazyContentAccessibilityDe,
        [Locale.EN]: LazyContentAccessibilityEn,
        [Locale.ES]: LazyContentAccessibilityEs,
        [Locale.FR]: LazyContentAccessibilityFr,
        [Locale.NL]: LazyContentAccessibilityNl,
        [Locale.IT]: LazyContentAccessibilityIt,
        [Locale.PL]: LazyContentAccessibilityPl,
        [Locale.PT]: LazyContentAccessibilityPt,
        [Locale.RO]: LazyContentAccessibilityRo,
        [Locale.RU]: LazyContentAccessibilityRu,
    };

    return componentByLocale[locale.value];
});
</script>

<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>
